/* eslint-disable lines-between-class-members */
import Enum from './Enum';

class StoreType extends Enum {
  OnlineOrder = 0; // 餐饮
  Retail = 1; // 零售
}

export default new StoreType();